import { IRoutes } from '../../../../routes';
import NavigationItem from './components/navigationItem';
import React, { useState } from 'react';
import './styles.scss';

interface Routes {
    routes: Array<IRoutes>;
    dealer?: string;
    permissionsMap: Map<string, Array<string>>;
}

export const NavigationMenu = ({ routes, dealer, permissionsMap }: Routes) => {
    const [openMenuName, setOpenMenuName] = useState<string | null>(null);

    const handleToggle = (name: string) => {
        setOpenMenuName((prev) => (prev === name ? null : name));
    };

    return (
        <div className={'navigation-menu'}>
            <ul className={'c-icon-list'}>
                {routes.map((ele, key) => {
                    return (
                        <NavigationItem
                            path={ele.path}
                            name={ele.name}
                            childs={ele.childs}
                            icon={ele.icon}
                            permissions={ele.permissions}
                            permissionsMap={permissionsMap}
                            dealer={dealer}
                            key={key}
                            isOpen={openMenuName === ele.name}
                            onToggle={() => handleToggle(ele.name)}
                        />
                    );
                })}
            </ul>
        </div>
    );
};
